'use client'

import React from 'react'
import {cx} from '@local/utils/cx'
import {Button} from '@local/ui/components'
import {useParams} from 'next/navigation'
import ChevronSVG from '@local/assets/svgs/chevron.svg'
import {useTranslate} from '@local/hooks'

export interface SideNavLargeProps {
	links: Array<{
		label: string;
		slug: string;
		type: string;
		location: string;
	}>;
	className?: string;
}

export const SideNavLarge = ({links, className}: SideNavLargeProps) => {
	const locale = useTranslate()
	const params = useParams()
	const slug = params.slug

	const stripLocation = (location) => {
		location = location.split(',')[0]
		return location
	}

	return (
		<div
			className={cx(
				'lg:sticky lg:top-0 margin-px-1 pb-60 lg:pb-287 bg-grey-4 lg:h-screen',
				className,
			)}>
			<div className='lg:h-237 lg-max:pt-76'>
				<h1 className='text-white font-serif text-34 lg-max:text-center lg:text-80 leading-snug tracking-tighter lg:tracking-tight  lg:pt-100 lg-max:p-50'>
					{locale('Careers')}
				</h1>
			</div>
			{links && (
				<ul
					className='lg:overflow-y-scroll lg:h-full lg:scrollbar-hide'
					data-lenis-prevent>
					{links.map((link, index) => (
						<li
							key={link.slug}
							className={cx(
								'transform-gpu transition-colors duration-300 ease-quart-out',
								'lg:h-80',
							)}>
							<Button
								href={`/career/${link.slug}`}
								className={cx(
									'w-full lg-max:py-20 h-full lg:pl-10 flex lg-max:flex-col lg-max:gap-24 lg:justify-between lg:items-center',
									'outline-none focus-visible:bg-grey-3',
									'hover:bg-grey-3',
									index > 0 && links[index - 1].slug === slug && 'border-none',
									slug === link.slug
										? 'bg-grey-2 rounded-xs'
										: 'border-t border-grey-1/30',
								)}>
								<h2 className='lg:span-w-2 text-left text-18 leading-moderate tracking-tight font-[350] normal-case text-white'>
									{link.label}
								</h2>
								<div className='grid grid-cols-4 lg:grid-cols-3 justify-items-end items-center gutter-gap-1 lg:span-w-3'>
									<p className='text-11 text-left lg:w-90 font-normal leading-none tracking-widest uppercase text-grey-1 lg-max:col-span-2 lg-max:justify-self-start'>
										{link.type}
									</p>
									<p className='text-11 font-normal leading-none tracking-widest uppercase text-grey-1'>
										{stripLocation(link.location)}
									</p>
									<ChevronSVG className='lg:mr-10 block w-13 -rotate-90 text-white' />
								</div>
							</Button>
						</li>
					))}
				</ul>
			)}
		</div>
	)
}
